import { cn } from '@/shared/lib/utils/classnames';
import type { DividerBlock as DividerBlockType } from '@/shared/types/blocks';

type DividerBlockProps = Omit<DividerBlockType, 'type' | 'id'>;

/**
 * DividerBlock - 구분선
 *
 * Figma 디자인 기준:
 * - 색상: #d9dde0 (label/weakest)
 * - 두께: 1px
 */
export function DividerBlock({ variant = 'solid', margin = 0 }: DividerBlockProps) {
  const variantClass = {
    solid: 'border-solid',
    dashed: 'border-dashed',
    dotted: 'border-dotted',
  }[variant];

  return (
    <hr
      className={cn('w-full border-t border-[#d9dde0]', variantClass)}
      style={{ marginTop: margin, marginBottom: margin }}
    />
  );
}
